var funHelper = {
  isInt: function (_val) {
    let regx = /^[1-9][0-9]*$/
    return regx.test(_val)
  },
  isNum: function (_val) {
    let regx = /^(-?\d+)(\.\d+)?$/
    return regx.test(_val)
  }
}
module.exports = funHelper
// Allow use of default import syntax in TypeScript
module.exports.default = funHelper
